module.exports = __webpack_public_path__ + "media/images/pic/hero/sea-949b3c4cfcbe099763241fd1ca7ce433.webp";